import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {StorageKeys} from '@app/core/constants/storage-keys';
import {PlatformStorage} from '@app/core/tokens/platform-storage.token';
import {StringUtils} from '@app/core/utils/string.utils';
import {selectRedirectUrl} from '@app/page-not-found/state/page-not-found.selector';
import {internalPages, publicPages, staticPages} from '@app/shared/constants';
import {ERole} from '@app/shared/enums/role.enum';
import {Store} from '@ngrx/store';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {catchError, map, of, withLatestFrom} from 'rxjs';
import {TokenUtils} from '../utils/token.utils';

export const userGuard: CanActivateFn = () => {
  const store = inject(Store);
  const oidcSecurityService = inject(OidcSecurityService);
  const storage = inject(PlatformStorage);
  const redirectUrl$ = store.select(selectRedirectUrl);
  const router = inject(Router);

  return oidcSecurityService.checkAuth().pipe(
    withLatestFrom(redirectUrl$),
    map(([auth, storeRedirectUrl]) => {
      const isPublicPage = publicPages.includes(window.location.pathname);
      const isStaticPage = staticPages.includes(window.location.pathname);
      const isInternalPage = internalPages.includes(window.location.pathname);
      const userRoles = TokenUtils.getUserRole(auth.accessToken);
      const isAuthorize = [ERole.Doctor, ERole.Manager].some(role => userRoles.includes(role));
      if (auth?.isAuthenticated && isAuthorize) {
        return true;
      } else if (auth?.isAuthenticated && !isAuthorize && !isPublicPage && !isStaticPage) {
        router.navigate(['/auth/unauthorized']);
        return false;
      } else {
        if (isInternalPage) {
          return false;
        }

        const redirectUrl = StringUtils.isEmpty(storeRedirectUrl) ? window.location.pathname : storeRedirectUrl;
        if (!publicPages.includes(redirectUrl) && !staticPages.includes(redirectUrl)) {
          storage.setItem(StorageKeys.redirectUrl, redirectUrl + window.location.search);
        }

        if (!isStaticPage) {
          oidcSecurityService.authorize();
        }
        return false;
      }
    }),
    catchError(() => {
      oidcSecurityService.authorize();
      return of(false);
    })
  );
};
